import PatientHeartRate from 'model/PatientHeartRate'
import WebRepository from '../web/WebRepository'
import Api from 'clients/web/Api'
import moment from 'moment'
//import DateUtils from './DateUtils'

export class PatientHeartRateRepository extends WebRepository<PatientHeartRate> {
  constructor() {
    super(new Api('heart_rate'))
  }

  async getLastValue(userId: any): Promise<any> {
    return super.search({
      limit: 1,
      sort: {
        start_timestamp: -1,
      },
      selector: {
        patientId: userId,
      },
    })
  }

  async searchByDate(
    userId: any,
    startDate: moment.Moment | undefined,
    endDate: moment.Moment | undefined,
  ): Promise<PatientHeartRate[]> {
    let startTimeInSeconds = startDate!.valueOf() / 1000
    let endTime = endDate!.valueOf() / 1000
    let boundaries = []

    var isDayPeriod = moment(startDate).isSame(moment(endDate), 'day')

    for (var i = startTimeInSeconds; i <= endTime + 1; i += isDayPeriod ? 60 : 24 * 60 * 60)
      boundaries.push(i)

    return super.aggregateAll(
      {
        selector: [
          {
            $match: {
              patientId: userId,
              start_timestamp: {
                $gt: startDate?.unix(),
                $lt: endDate?.unix(),
              },
            },
          },
          {
            $bucket: {
              groupBy: '$start_timestamp',
              boundaries: boundaries,
              output: {
                sum: {
                  $sum: '$avg',
                },
                count: {
                  $sum: 1,
                },
              },
            },
          },
          {
            $addFields: {
              avg: {
                $divide: ['$sum', '$count'],
              },
              start_timestamp: '$_id',
            },
          },
          {
            $project: {
              sum: 0,
              count: 0,
              _id: 0,
            },
          },
        ],
      },
      (doc: any) => {
        return {
          start_timestamp: doc.start_timestamp,
          isDayPeriod: isDayPeriod,
          avg: doc.avg,
        }
      },
    )
  }
}

export default new PatientHeartRateRepository()
